/* tslint:disable */
/* eslint-disable */
/**
 * OnData.SecureAI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface CommonLlmProviderResponse
 */
export interface CommonLlmProviderResponse {
    /**
     * 
     * @type {{ [key: string]: Array<LlmModelDto>; }}
     * @memberof CommonLlmProviderResponse
     */
    'data'?: { [key: string]: Array<LlmModelDto>; } | null;
}
/**
 * 
 * @export
 * @interface ContainerRegistryPullPasswordDto
 */
export interface ContainerRegistryPullPasswordDto {
    /**
     * 
     * @type {string}
     * @memberof ContainerRegistryPullPasswordDto
     */
    'password'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContainerRegistryPullPasswordDto
     */
    'loginServer'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContainerRegistryPullPasswordDto
     */
    'tokenName'?: string | null;
}
/**
 * 
 * @export
 * @interface DataAccessRoleResponseDto
 */
export interface DataAccessRoleResponseDto {
    /**
     * 
     * @type {number}
     * @memberof DataAccessRoleResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DataAccessRoleResponseDto
     */
    'roleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DataAccessRoleResponseDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataAccessRoleResponseDto
     */
    'value'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataAccessRoleResponseDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof DataAccessRoleResponseDto
     */
    'readGrants'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof DataAccessRoleResponseDto
     */
    'writeGrants'?: Array<number> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum DatabaseType {
    MySQL = 1,
    PostgreSQL = 2,
    SQLServer = 3,
    MongoDB = 4,
    MariaDB = 5,
    Oracle = 6,
    DB2 = 7,
    Hana = 8,
    Snowflake = 9,
    CosmosDB = 10
}

/**
 * 
 * @export
 * @interface DetectPattern
 */
export interface DetectPattern {
    /**
     * 
     * @type {string}
     * @memberof DetectPattern
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DetectPattern
     */
    'score'?: number;
    /**
     * 
     * @type {string}
     * @memberof DetectPattern
     */
    'regex'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum EmailType {
    Unknown = 0,
    UserInvite = 2,
    ResetPassword = 3,
    GenericAlert = 4,
    MFA = 5
}

/**
 * 
 * @export
 * @interface ErrorLogDto
 */
export interface ErrorLogDto {
    /**
     * 
     * @type {string}
     * @memberof ErrorLogDto
     */
    'errorType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ErrorLogDto
     */
    'message'?: string | null;
    /**
     * 
     * @type {OnDataLogLevel}
     * @memberof ErrorLogDto
     */
    'logLevel'?: OnDataLogLevel;
    /**
     * 
     * @type {number}
     * @memberof ErrorLogDto
     */
    'applicationType'?: number;
    /**
     * 
     * @type {string}
     * @memberof ErrorLogDto
     */
    'applicationName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ErrorLogDto
     */
    'stackTrace'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ErrorLogDto
     */
    'contextInfo'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ErrorLogDto
     */
    'reportTime'?: string;
}
/**
 * 
 * @export
 * @interface ErrorLogDtoPaginationResult
 */
export interface ErrorLogDtoPaginationResult {
    /**
     * 
     * @type {Array<ErrorLogDto>}
     * @memberof ErrorLogDtoPaginationResult
     */
    'items'?: Array<ErrorLogDto> | null;
    /**
     * 
     * @type {number}
     * @memberof ErrorLogDtoPaginationResult
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface ExclusionRule
 */
export interface ExclusionRule {
    /**
     * 
     * @type {Array<string>}
     * @memberof ExclusionRule
     */
    'words'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ExclusionRule
     */
    'regex'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExclusionRule
     */
    'excludeInfoTypes'?: Array<string> | null;
    /**
     * 
     * @type {KeywordRule}
     * @memberof ExclusionRule
     */
    'excludeByKeyword'?: KeywordRule;
}
/**
 * 
 * @export
 * @interface InfoTypeInput
 */
export interface InfoTypeInput {
    /**
     * 
     * @type {string}
     * @memberof InfoTypeInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof InfoTypeInput
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfoTypeInput
     */
    'description'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof InfoTypeInput
     */
    'denyList'?: Array<string> | null;
    /**
     * 
     * @type {Array<DetectPattern>}
     * @memberof InfoTypeInput
     */
    'detectPatterns'?: Array<DetectPattern> | null;
    /**
     * 
     * @type {Array<KeywordRule>}
     * @memberof InfoTypeInput
     */
    'keywordRules'?: Array<KeywordRule> | null;
    /**
     * 
     * @type {Array<ExclusionRule>}
     * @memberof InfoTypeInput
     */
    'exclusionRules'?: Array<ExclusionRule> | null;
    /**
     * 
     * @type {boolean}
     * @memberof InfoTypeInput
     */
    'isEnabled'?: boolean;
}
/**
 * 
 * @export
 * @interface InfoTypeResponseDto
 */
export interface InfoTypeResponseDto {
    /**
     * 
     * @type {string}
     * @memberof InfoTypeResponseDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfoTypeResponseDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfoTypeResponseDto
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfoTypeResponseDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof InfoTypeResponseDto
     */
    'isBuiltIn'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof InfoTypeResponseDto
     */
    'denyList'?: Array<string> | null;
    /**
     * 
     * @type {Array<DetectPattern>}
     * @memberof InfoTypeResponseDto
     */
    'detectPatterns'?: Array<DetectPattern> | null;
    /**
     * 
     * @type {Array<KeywordRule>}
     * @memberof InfoTypeResponseDto
     */
    'keywordRules'?: Array<KeywordRule> | null;
    /**
     * 
     * @type {Array<ExclusionRule>}
     * @memberof InfoTypeResponseDto
     */
    'exclusionRules'?: Array<ExclusionRule> | null;
    /**
     * 
     * @type {boolean}
     * @memberof InfoTypeResponseDto
     */
    'isEnabled'?: boolean;
}
/**
 * 
 * @export
 * @interface InitSystemAdminInput
 */
export interface InitSystemAdminInput {
    /**
     * 
     * @type {string}
     * @memberof InitSystemAdminInput
     */
    'username': string;
}
/**
 * 
 * @export
 * @interface InternalUserResponseDto
 */
export interface InternalUserResponseDto {
    /**
     * 
     * @type {number}
     * @memberof InternalUserResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof InternalUserResponseDto
     */
    'userId'?: number;
    /**
     * 
     * @type {string}
     * @memberof InternalUserResponseDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InternalUserResponseDto
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InternalUserResponseDto
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InternalUserResponseDto
     */
    'phone'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof InternalUserResponseDto
     */
    'isMtfWayPhone'?: boolean;
}
/**
 * 
 * @export
 * @interface KeywordRule
 */
export interface KeywordRule {
    /**
     * 
     * @type {Array<string>}
     * @memberof KeywordRule
     */
    'words'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof KeywordRule
     */
    'regex'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof KeywordRule
     */
    'windowBefore'?: number;
    /**
     * 
     * @type {number}
     * @memberof KeywordRule
     */
    'windowAfter'?: number;
    /**
     * 
     * @type {number}
     * @memberof KeywordRule
     */
    'scoreAdjustment'?: number;
}
/**
 * 
 * @export
 * @interface LlmModelDto
 */
export interface LlmModelDto {
    /**
     * 
     * @type {string}
     * @memberof LlmModelDto
     */
    'providerName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LlmModelDto
     */
    'apiUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LlmModelDto
     */
    'modelId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LlmModelDto
     */
    'apiType'?: string | null;
}
/**
 * 
 * @export
 * @interface McpServerClientDto
 */
export interface McpServerClientDto {
    /**
     * 
     * @type {number}
     * @memberof McpServerClientDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof McpServerClientDto
     */
    'clientId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof McpServerClientDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof McpServerClientDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof McpServerClientDto
     */
    'url'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof McpServerClientDto
     */
    'databaseId'?: number;
    /**
     * 
     * @type {string}
     * @memberof McpServerClientDto
     */
    'databaseName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof McpServerClientDto
     */
    'databaseEngine'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof McpServerClientDto
     */
    'serverAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof McpServerClientDto
     */
    'driverClientId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof McpServerClientDto
     */
    'driverClientName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof McpServerClientDto
     */
    'port'?: number;
    /**
     * 
     * @type {OperatingMode}
     * @memberof McpServerClientDto
     */
    'driverOperatingMode'?: OperatingMode;
    /**
     * 
     * @type {string}
     * @memberof McpServerClientDto
     */
    'lastStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof McpServerClientDto
     */
    'onlineStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof McpServerClientDto
     */
    'lastReportTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof McpServerClientDto
     */
    'message'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof McpServerClientDto
     */
    'isEnabled'?: boolean;
}
/**
 * 
 * @export
 * @interface McpServerClientDtoPaginationResult
 */
export interface McpServerClientDtoPaginationResult {
    /**
     * 
     * @type {Array<McpServerClientDto>}
     * @memberof McpServerClientDtoPaginationResult
     */
    'items'?: Array<McpServerClientDto> | null;
    /**
     * 
     * @type {number}
     * @memberof McpServerClientDtoPaginationResult
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface McpServerInfoUpdateDto
 */
export interface McpServerInfoUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof McpServerInfoUpdateDto
     */
    'clientId': string;
    /**
     * 
     * @type {string}
     * @memberof McpServerInfoUpdateDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof McpServerInfoUpdateDto
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface McpServerReportDto
 */
export interface McpServerReportDto {
    /**
     * 
     * @type {boolean}
     * @memberof McpServerReportDto
     */
    'isRunning'?: boolean;
    /**
     * 
     * @type {DatabaseType}
     * @memberof McpServerReportDto
     */
    'databaseEngineType'?: DatabaseType;
    /**
     * 
     * @type {string}
     * @memberof McpServerReportDto
     */
    'databaseVersion'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof McpServerReportDto
     */
    'databaseEdition'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof McpServerReportDto
     */
    'databaseAddress'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof McpServerReportDto
     */
    'databasePort'?: number;
    /**
     * 
     * @type {string}
     * @memberof McpServerReportDto
     */
    'databaseName'?: string | null;
    /**
     * 
     * @type {OperatingMode}
     * @memberof McpServerReportDto
     */
    'operatingMode'?: OperatingMode;
    /**
     * 
     * @type {string}
     * @memberof McpServerReportDto
     */
    'driverClientId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof McpServerReportDto
     */
    'message'?: string | null;
}
/**
 * 
 * @export
 * @interface McpServerSearchInput
 */
export interface McpServerSearchInput {
    /**
     * 
     * @type {string}
     * @memberof McpServerSearchInput
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof McpServerSearchInput
     */
    'status'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof McpServerSearchInput
     */
    'pageIndex'?: number;
    /**
     * 
     * @type {number}
     * @memberof McpServerSearchInput
     */
    'pageSize'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof McpServerSearchInput
     */
    'sortAsc'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum OnDataLogLevel {
    Info = 0,
    Warning = 1,
    Error = 2,
    Critical = 3
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum OperatingMode {
    Encryption = 0,
    Decryption = 1,
    ApplyEncryptionSettings = 2,
    MigrateAndEncrypt = 3
}

/**
 * 
 * @export
 * @interface SearchErrorLogInput
 */
export interface SearchErrorLogInput {
    /**
     * 
     * @type {string}
     * @memberof SearchErrorLogInput
     */
    'fromTs'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchErrorLogInput
     */
    'toTs'?: string;
    /**
     * 
     * @type {number}
     * @memberof SearchErrorLogInput
     */
    'pageSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchErrorLogInput
     */
    'pageIndex'?: number;
}
/**
 * 
 * @export
 * @interface SecureAIClientDto
 */
export interface SecureAIClientDto {
    /**
     * 
     * @type {number}
     * @memberof SecureAIClientDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SecureAIClientDto
     */
    'clientId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SecureAIClientDto
     */
    'clientName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SecureAIClientDto
     */
    'logoUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SecureAIClientDto
     */
    'lastStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SecureAIClientDto
     */
    'onlineStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SecureAIClientDto
     */
    'lastReportTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof SecureAIClientDto
     */
    'message'?: string | null;
    /**
     * 
     * @type {Array<McpServerClientDto>}
     * @memberof SecureAIClientDto
     */
    'assignedMcpServers'?: Array<McpServerClientDto> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SecureAIClientDto
     */
    'assignedMcpServerIds'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface SecureAIReportDto
 */
export interface SecureAIReportDto {
    /**
     * 
     * @type {boolean}
     * @memberof SecureAIReportDto
     */
    'isRunning'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SecureAIReportDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SecureAIReportDto
     */
    'clientId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SecureAIReportDto
     */
    'clientName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SecureAIReportDto
     */
    'logoUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SecureAIReportDto
     */
    'lastStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SecureAIReportDto
     */
    'lastReportTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof SecureAIReportDto
     */
    'message'?: string | null;
    /**
     * 
     * @type {Array<McpServerClientDto>}
     * @memberof SecureAIReportDto
     */
    'mcpClientList'?: Array<McpServerClientDto> | null;
}
/**
 * 
 * @export
 * @interface SendEmailInput
 */
export interface SendEmailInput {
    /**
     * 
     * @type {string}
     * @memberof SendEmailInput
     */
    'to': string;
    /**
     * 
     * @type {string}
     * @memberof SendEmailInput
     */
    'toDisplayName'?: string | null;
    /**
     * 
     * @type {EmailType}
     * @memberof SendEmailInput
     */
    'emailType': EmailType;
    /**
     * 
     * @type {string}
     * @memberof SendEmailInput
     */
    'url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SendEmailInput
     */
    'code'?: string | null;
}
/**
 * 
 * @export
 * @interface SendSmsInput
 */
export interface SendSmsInput {
    /**
     * 
     * @type {string}
     * @memberof SendSmsInput
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof SendSmsInput
     */
    'code': string;
}

/**
 * SecureAIApi - axios parameter creator
 * @export
 */
export const SecureAIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} clientId 
         * @param {SearchErrorLogInput} [searchErrorLogInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiErrorlogsSearchClientIdPost: async (clientId: string, searchErrorLogInput?: SearchErrorLogInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiErrorlogsSearchClientIdPost', 'clientId', clientId)
            const localVarPath = `/api/errorlogs/search/{clientId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchErrorLogInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMcpserversDetailClientIdDelete: async (clientId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiMcpserversDetailClientIdDelete', 'clientId', clientId)
            const localVarPath = `/api/mcpservers/detail/{clientId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMcpserversDetailClientIdGet: async (clientId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiMcpserversDetailClientIdGet', 'clientId', clientId)
            const localVarPath = `/api/mcpservers/detail/{clientId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} clientId 
         * @param {McpServerInfoUpdateDto} [mcpServerInfoUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMcpserversDetailClientIdPut: async (clientId: string, mcpServerInfoUpdateDto?: McpServerInfoUpdateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiMcpserversDetailClientIdPut', 'clientId', clientId)
            const localVarPath = `/api/mcpservers/detail/{clientId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mcpServerInfoUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMcpserversListGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/mcpservers/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMcpserversPullPasswordPost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/mcpservers/pull-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMcpserversRepoAuthnInfoGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/mcpservers/repo-authn-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {McpServerSearchInput} [mcpServerSearchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMcpserversSearchPost: async (mcpServerSearchInput?: McpServerSearchInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/mcpservers/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mcpServerSearchInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} clientId 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSecureaiAssignMcpsClientIdPost: async (clientId: string, requestBody?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiSecureaiAssignMcpsClientIdPost', 'clientId', clientId)
            const localVarPath = `/api/secureai/assign-mcps/{clientId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSecureaiClientIdDelete: async (clientId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('apiSecureaiClientIdDelete', 'clientId', clientId)
            const localVarPath = `/api/secureai/{clientId}`
                .replace(`{${"clientId"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSecureaiInfotypesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/secureai/infotypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSecureaiInfotypesIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiSecureaiInfotypesIdDelete', 'id', id)
            const localVarPath = `/api/secureai/infotypes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSecureaiInfotypesIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiSecureaiInfotypesIdGet', 'id', id)
            const localVarPath = `/api/secureai/infotypes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {InfoTypeInput} [infoTypeInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSecureaiInfotypesIdPut: async (id: string, infoTypeInput?: InfoTypeInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiSecureaiInfotypesIdPut', 'id', id)
            const localVarPath = `/api/secureai/infotypes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(infoTypeInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {InfoTypeInput} [infoTypeInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSecureaiInfotypesPost: async (infoTypeInput?: InfoTypeInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/secureai/infotypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(infoTypeInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSecureaiListGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/secureai/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSecureaiPullPasswordPost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/secureai/pull-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSecureaiRepoAuthnInfoGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/secureai/repo-authn-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SecureAIApi - functional programming interface
 * @export
 */
export const SecureAIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SecureAIApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} clientId 
         * @param {SearchErrorLogInput} [searchErrorLogInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiErrorlogsSearchClientIdPost(clientId: string, searchErrorLogInput?: SearchErrorLogInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ErrorLogDtoPaginationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiErrorlogsSearchClientIdPost(clientId, searchErrorLogInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMcpserversDetailClientIdDelete(clientId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMcpserversDetailClientIdDelete(clientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMcpserversDetailClientIdGet(clientId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<McpServerClientDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMcpserversDetailClientIdGet(clientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} clientId 
         * @param {McpServerInfoUpdateDto} [mcpServerInfoUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMcpserversDetailClientIdPut(clientId: string, mcpServerInfoUpdateDto?: McpServerInfoUpdateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMcpserversDetailClientIdPut(clientId, mcpServerInfoUpdateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMcpserversListGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<McpServerClientDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMcpserversListGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMcpserversPullPasswordPost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContainerRegistryPullPasswordDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMcpserversPullPasswordPost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMcpserversRepoAuthnInfoGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContainerRegistryPullPasswordDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMcpserversRepoAuthnInfoGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {McpServerSearchInput} [mcpServerSearchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMcpserversSearchPost(mcpServerSearchInput?: McpServerSearchInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<McpServerClientDtoPaginationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMcpserversSearchPost(mcpServerSearchInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} clientId 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSecureaiAssignMcpsClientIdPost(clientId: string, requestBody?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSecureaiAssignMcpsClientIdPost(clientId, requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSecureaiClientIdDelete(clientId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSecureaiClientIdDelete(clientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSecureaiInfotypesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InfoTypeResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSecureaiInfotypesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSecureaiInfotypesIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSecureaiInfotypesIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSecureaiInfotypesIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InfoTypeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSecureaiInfotypesIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {InfoTypeInput} [infoTypeInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSecureaiInfotypesIdPut(id: string, infoTypeInput?: InfoTypeInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSecureaiInfotypesIdPut(id, infoTypeInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {InfoTypeInput} [infoTypeInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSecureaiInfotypesPost(infoTypeInput?: InfoTypeInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InfoTypeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSecureaiInfotypesPost(infoTypeInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSecureaiListGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SecureAIClientDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSecureaiListGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSecureaiPullPasswordPost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContainerRegistryPullPasswordDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSecureaiPullPasswordPost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSecureaiRepoAuthnInfoGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContainerRegistryPullPasswordDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSecureaiRepoAuthnInfoGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SecureAIApi - factory interface
 * @export
 */
export const SecureAIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SecureAIApiFp(configuration)
    return {
        /**
         * 
         * @param {string} clientId 
         * @param {SearchErrorLogInput} [searchErrorLogInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiErrorlogsSearchClientIdPost(clientId: string, searchErrorLogInput?: SearchErrorLogInput, options?: any): AxiosPromise<ErrorLogDtoPaginationResult> {
            return localVarFp.apiErrorlogsSearchClientIdPost(clientId, searchErrorLogInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMcpserversDetailClientIdDelete(clientId: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiMcpserversDetailClientIdDelete(clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMcpserversDetailClientIdGet(clientId: string, options?: any): AxiosPromise<McpServerClientDto> {
            return localVarFp.apiMcpserversDetailClientIdGet(clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} clientId 
         * @param {McpServerInfoUpdateDto} [mcpServerInfoUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMcpserversDetailClientIdPut(clientId: string, mcpServerInfoUpdateDto?: McpServerInfoUpdateDto, options?: any): AxiosPromise<void> {
            return localVarFp.apiMcpserversDetailClientIdPut(clientId, mcpServerInfoUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMcpserversListGet(options?: any): AxiosPromise<Array<McpServerClientDto>> {
            return localVarFp.apiMcpserversListGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMcpserversPullPasswordPost(options?: any): AxiosPromise<ContainerRegistryPullPasswordDto> {
            return localVarFp.apiMcpserversPullPasswordPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMcpserversRepoAuthnInfoGet(options?: any): AxiosPromise<ContainerRegistryPullPasswordDto> {
            return localVarFp.apiMcpserversRepoAuthnInfoGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {McpServerSearchInput} [mcpServerSearchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMcpserversSearchPost(mcpServerSearchInput?: McpServerSearchInput, options?: any): AxiosPromise<McpServerClientDtoPaginationResult> {
            return localVarFp.apiMcpserversSearchPost(mcpServerSearchInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} clientId 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSecureaiAssignMcpsClientIdPost(clientId: string, requestBody?: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.apiSecureaiAssignMcpsClientIdPost(clientId, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSecureaiClientIdDelete(clientId: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiSecureaiClientIdDelete(clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSecureaiInfotypesGet(options?: any): AxiosPromise<Array<InfoTypeResponseDto>> {
            return localVarFp.apiSecureaiInfotypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSecureaiInfotypesIdDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiSecureaiInfotypesIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSecureaiInfotypesIdGet(id: string, options?: any): AxiosPromise<InfoTypeResponseDto> {
            return localVarFp.apiSecureaiInfotypesIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {InfoTypeInput} [infoTypeInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSecureaiInfotypesIdPut(id: string, infoTypeInput?: InfoTypeInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiSecureaiInfotypesIdPut(id, infoTypeInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InfoTypeInput} [infoTypeInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSecureaiInfotypesPost(infoTypeInput?: InfoTypeInput, options?: any): AxiosPromise<InfoTypeResponseDto> {
            return localVarFp.apiSecureaiInfotypesPost(infoTypeInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSecureaiListGet(options?: any): AxiosPromise<Array<SecureAIClientDto>> {
            return localVarFp.apiSecureaiListGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSecureaiPullPasswordPost(options?: any): AxiosPromise<ContainerRegistryPullPasswordDto> {
            return localVarFp.apiSecureaiPullPasswordPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSecureaiRepoAuthnInfoGet(options?: any): AxiosPromise<ContainerRegistryPullPasswordDto> {
            return localVarFp.apiSecureaiRepoAuthnInfoGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SecureAIApi - object-oriented interface
 * @export
 * @class SecureAIApi
 * @extends {BaseAPI}
 */
export class SecureAIApi extends BaseAPI {
    /**
     * 
     * @param {string} clientId 
     * @param {SearchErrorLogInput} [searchErrorLogInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureAIApi
     */
    public apiErrorlogsSearchClientIdPost(clientId: string, searchErrorLogInput?: SearchErrorLogInput, options?: AxiosRequestConfig) {
        return SecureAIApiFp(this.configuration).apiErrorlogsSearchClientIdPost(clientId, searchErrorLogInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureAIApi
     */
    public apiMcpserversDetailClientIdDelete(clientId: string, options?: AxiosRequestConfig) {
        return SecureAIApiFp(this.configuration).apiMcpserversDetailClientIdDelete(clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureAIApi
     */
    public apiMcpserversDetailClientIdGet(clientId: string, options?: AxiosRequestConfig) {
        return SecureAIApiFp(this.configuration).apiMcpserversDetailClientIdGet(clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} clientId 
     * @param {McpServerInfoUpdateDto} [mcpServerInfoUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureAIApi
     */
    public apiMcpserversDetailClientIdPut(clientId: string, mcpServerInfoUpdateDto?: McpServerInfoUpdateDto, options?: AxiosRequestConfig) {
        return SecureAIApiFp(this.configuration).apiMcpserversDetailClientIdPut(clientId, mcpServerInfoUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureAIApi
     */
    public apiMcpserversListGet(options?: AxiosRequestConfig) {
        return SecureAIApiFp(this.configuration).apiMcpserversListGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureAIApi
     */
    public apiMcpserversPullPasswordPost(options?: AxiosRequestConfig) {
        return SecureAIApiFp(this.configuration).apiMcpserversPullPasswordPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureAIApi
     */
    public apiMcpserversRepoAuthnInfoGet(options?: AxiosRequestConfig) {
        return SecureAIApiFp(this.configuration).apiMcpserversRepoAuthnInfoGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {McpServerSearchInput} [mcpServerSearchInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureAIApi
     */
    public apiMcpserversSearchPost(mcpServerSearchInput?: McpServerSearchInput, options?: AxiosRequestConfig) {
        return SecureAIApiFp(this.configuration).apiMcpserversSearchPost(mcpServerSearchInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} clientId 
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureAIApi
     */
    public apiSecureaiAssignMcpsClientIdPost(clientId: string, requestBody?: Array<string>, options?: AxiosRequestConfig) {
        return SecureAIApiFp(this.configuration).apiSecureaiAssignMcpsClientIdPost(clientId, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureAIApi
     */
    public apiSecureaiClientIdDelete(clientId: string, options?: AxiosRequestConfig) {
        return SecureAIApiFp(this.configuration).apiSecureaiClientIdDelete(clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureAIApi
     */
    public apiSecureaiInfotypesGet(options?: AxiosRequestConfig) {
        return SecureAIApiFp(this.configuration).apiSecureaiInfotypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureAIApi
     */
    public apiSecureaiInfotypesIdDelete(id: string, options?: AxiosRequestConfig) {
        return SecureAIApiFp(this.configuration).apiSecureaiInfotypesIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureAIApi
     */
    public apiSecureaiInfotypesIdGet(id: string, options?: AxiosRequestConfig) {
        return SecureAIApiFp(this.configuration).apiSecureaiInfotypesIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {InfoTypeInput} [infoTypeInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureAIApi
     */
    public apiSecureaiInfotypesIdPut(id: string, infoTypeInput?: InfoTypeInput, options?: AxiosRequestConfig) {
        return SecureAIApiFp(this.configuration).apiSecureaiInfotypesIdPut(id, infoTypeInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InfoTypeInput} [infoTypeInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureAIApi
     */
    public apiSecureaiInfotypesPost(infoTypeInput?: InfoTypeInput, options?: AxiosRequestConfig) {
        return SecureAIApiFp(this.configuration).apiSecureaiInfotypesPost(infoTypeInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureAIApi
     */
    public apiSecureaiListGet(options?: AxiosRequestConfig) {
        return SecureAIApiFp(this.configuration).apiSecureaiListGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureAIApi
     */
    public apiSecureaiPullPasswordPost(options?: AxiosRequestConfig) {
        return SecureAIApiFp(this.configuration).apiSecureaiPullPasswordPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureAIApi
     */
    public apiSecureaiRepoAuthnInfoGet(options?: AxiosRequestConfig) {
        return SecureAIApiFp(this.configuration).apiSecureaiRepoAuthnInfoGet(options).then((request) => request(this.axios, this.basePath));
    }
}


